export class UserData {
    public language: string;
    public hideTutorial: boolean;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.language = json.language;
            this.hideTutorial = json.hideTutorial;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/userData.ts